import { trackGA4Event } from '@gumtree/shared/src/util/ga4-shared';
import { VipThunk } from '.';
import * as postCallReminderUtils from '../utils/post-call-reminder';
import * as postCallMessageEncourageUtils from '../utils/post-call-message-encourage';

const initialState = {
    showReminder: false,
    showMessageEncourage: false,
    showOutOfHoursMessage: false,
};

export const SET_POST_CALL_REMINDER = 'set_post_call_reminder';
export const SET_SHOW_MESSAGE_ENCOURAGE = 'set_show_message_encourage';
export const SET_SHOW_OUT_OF_HOURS_MESSAGE = 'set_show_out_of_hours_message';

// post call reminder
export const setPostCallReminder = (show: boolean) => ({
    type: SET_POST_CALL_REMINDER,
    payload: show,
});

export const updatePostCallReminder: VipThunk<boolean> =
    (show: boolean) => (dispatch, getState) => {
        const { adDetails, userData, postCall } = getState();
        if (show) {
            if (adDetails.userSentMessage || postCall.showReminder) return;
            if (postCallReminderUtils.hasReminder(adDetails.id, userData.id)) return;

            trackGA4Event<GA4.CtaPostCallReminder>({
                event: 'call_reminder_view',
            });

            postCallReminderUtils.setReminder(adDetails.id, userData.id);
            dispatch(setPostCallReminder(true));
        } else {
            dispatch(setPostCallReminder(false));
        }
    };

export const fetchPostCallReminder: VipThunk<void> = () => (dispatch, getState) => {
    const { adDetails, userData, postCall } = getState();
    if (adDetails.userSentMessage || postCall.showReminder) return;
    if (!postCallReminderUtils.hasValidReminder(adDetails.id, userData.id)) return;

    trackGA4Event<GA4.CtaPostCallReminder>({
        event: 'call_reminder_view',
    });

    dispatch(setPostCallReminder(true));
};

// post call message encourage
export const setShowMessageEncourage = (show: boolean) => ({
    type: SET_SHOW_MESSAGE_ENCOURAGE,
    payload: show,
});

export const updateShowMessageEncourage: VipThunk<boolean> = (show: boolean) => (dispatch, getState) => {
    const { adDetails, postCall, userData } = getState();
    if (show) {
        if (postCall.showMessageEncourage || adDetails.userSentMessage) return; 
        if (!postCallMessageEncourageUtils.canShow(adDetails.id, userData.id)) return;
        postCallMessageEncourageUtils.set(adDetails.id, userData.id);
        trackGA4Event<GA4.EditMessagePopup>({
            event: 'edit_message_popup',
        });
    }
    dispatch(setShowMessageEncourage(show));
};

export const setShowOutOfHoursMessage = (show: boolean) => ({
    type: SET_SHOW_OUT_OF_HOURS_MESSAGE,
    payload: show,
});


export const updateShowOutOfHoursMessage: VipThunk<boolean> = (show: boolean) => (dispatch, getState) => {
    const { postCall } = getState();
    if (show) {
        if (postCall.showOutOfHoursMessage) return;
        trackGA4Event<GA4.OutOfHoursPopup>({
            event: 'out_of_hours_view',
        });
    }
    dispatch(setShowOutOfHoursMessage(show));
};

type Action = ReturnType<typeof setPostCallReminder> | ReturnType<typeof setShowMessageEncourage> | ReturnType<typeof setShowOutOfHoursMessage>;

export default (state = initialState, action: Action) => {
    switch (action.type) {
        case SET_POST_CALL_REMINDER:
            return {
                ...state,
                showReminder: action.payload,
            };
        case SET_SHOW_MESSAGE_ENCOURAGE:
            return {
                ...state,
                showMessageEncourage: action.payload,
            };
        case SET_SHOW_OUT_OF_HOURS_MESSAGE:
            return {
                ...state,
                showOutOfHoursMessage: action.payload,
            };
        default:
            return state;
    }
};
